
<hierarchy-data-table *ngIf="tableType === enums.dataTableTypes.hierarchy"></hierarchy-data-table>

<paged-sorted-data-table *ngIf="tableType === enums.dataTableTypes.pagedSorted"></paged-sorted-data-table>

<trend-data-table *ngIf="tableType === enums.dataTableTypes.trend"></trend-data-table>
